const capFirst = s => {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

const makeCommonStore = (state, readOnlyItems = []) => {
  const getters = {}
  let mutations = {}
  let actions = {}

  for (let k in state) {
    getters[k] = (st) => st._data[k]
  }
  for (let k in state) {
    if (readOnlyItems.indexOf(k) >= 0) {
      continue
    }
    let K = 'update' + capFirst(k)
    mutations[K] = (st, v) => { st._data[k] = v }
  }

  for (let k in state) {
    if (readOnlyItems.indexOf(k) >= 0) {
      continue
    }
    let capName = capFirst(k)
    let K = 'set' + capName
    let evt = 'update' + capName
    actions[K] = ({ commit }, v) => { commit(evt, v) }
  }

  mutations = {
    ...mutations,
    updateFieldItems (state, items) {
      const fields = state._data.fields
      for (let item of items) {
        for (let v of fields) {
          if (v.name === item.name) {
            if (v.type === 'address') {
              v.value = item.value ? item.value.dpid : null
              v.text = item.value ? item.value.formatted : ''
            } else {
              v.value = item.value
            }
            break
          }
        }
      }
    }
  }

  actions = {
    ...actions,

    setFieldItems ({ commit, state }, data) {
      let savingData = {}
      for (let v of data.items) {
        savingData[v.name] = v.value
      }
      if (data.id) {
        return state._data.service.partial_update(data.id, savingData)
          .then(resp => {
            commit('updateFieldItems', data.items)
          })
      } else {
        return state._data.service.create(savingData)
          .then(resp => {
            commit('updateFieldItems', data.items)
          })
      }
    },

    updateFromAPI ({ commit, state }, pk) {
      return state._data.service.get(pk)
        .then(resp => {
          const items = Object.keys(resp.data).map(k => {
            return { name: k, value: resp.data[k] }
          })
          commit('updateFieldItems', items)
        })
    },

    serviceGet ({ commit, state }, pk) {
      return state._data.service.get(pk)
    },

    setFieldItemsNoSend ({ commit, state }, data) {
      commit('updateFieldItems', data)
    }
  }

  return {
    state: { _data: state },
    getters: { ...getters },
    mutations: { ...mutations },
    actions: { ...actions }
  }
}

class FormField {
  constructor (data) {
    this.name = data.name
    this.type = data.type || 'text'
    this.label = data.label
    this.icon = data.icon
    this.value = data.value
    this.items = data.items
    this.text = data.text
    this.rules = data.rules
    this.mask = data.mask
    this.hidden = data.hidden || false
    this.disabled = data.disabled || false
    this.placeholder = data.placeholder
    this.cols = data.cols || 12
    this.sm = data.sm || this.cols
    this.md = data.md || 6
    this.lg = data.lg || this.md
    this.xl = data.xl || this.lg
    this._loading = false
  }
}

export { makeCommonStore, FormField }
